import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { OnboardingRoute } from 'routes/account.routes';
import { ProductsRoute } from 'routes/product.routes';
import { replace } from 'utils/common.util';

const Index: React.FC = () => {
  const router = useRouter();
  const { next, referrer } = router.query;
  useEffect(() => {
    const seeOnboarding = localStorage.getItem('seeOnboarding');
    replace(
      seeOnboarding ? ProductsRoute() : OnboardingRoute(next, referrer),
    )();
  }, []);

  return null;
};

export default Index;
